export let life = {};
export let event = {
  // 确认属实或失实
  confirm(value) {
    this.methods('updateAudit', value);
  },
  // 点击取消
  cancel() {
    this.methods('toggleDialog', false);
  }
};
export let watch = {
  row: {
    handler(v) {
      this.methods('updateFormModel');
    },
    deep: true
  },
  // 取消时恢复表单
  visible(now, old) {
    if (old && !now) {
      this.methods('updateFormModel');
    }
  }
};
